import { Constants } from 'src/shared/utilities/constants.util';

export class AuditWebEventTrackerModel {
		
	eventId: string = '';	
	eventType: string = '';	
	sourceIP: string = '';
	targetIP: string = '';
	success: boolean = true;
	eventResult: string = '';
	httpMethod: string = '';
	requestURL: string = '';
	protocolVersion: string = '';
	httpStatusCode: string = '';
	responseSize: number = 0;
	description: string = '';
	sourceFilePath: string = '';
	sourceLineNumber: string = '0';

	userId: number = 0;
	message: string = '';
	applicationAbbreviation: string = Constants.HuronAcceleratorsAbbreviation;
	actionCategory: AuditTrackingCategory = AuditTrackingCategory.featureUsage;
	eventDateTime = Date();
}

export enum AuditTrackingCategory {
	administrativePrivilegesUsed = "AdministrativePrivilegesUsed",
	applicationError = "ApplicationError",
	applicationStartUp = "ApplicationStartUp",
	applicationShutDown = "ApplicationShutDown",
	authenticationFailure = "AuthenticationFailure",
	authenticationSuccess = "AuthenticationSuccess",
	authorizationFailure = "AuthorizationFailure",
	clickTracking = "ClickTracking",
	configurationSettingsChange = "ConfigurationSettingsChange",
	failedAccessAttempts = "FailedAccessAttempts",
	featureUsage = "FeatureUsage",
	fileUploadVirusDetection = "FileUploadVirusDetection",
	impersonateUser = "ImpersonateUser",
	maintenanceToolsUsed = "MaintenanceToolsUsed",
	passwordChange = "PasswordChange",
	privilegedFunctionsUsed = "PrivilegedFunctionsUsed",
	remoteAccess = "RemoteAccess",
	serverShutDown = "ServerShutDown",
	serverStartUp = "ServerStartUp",
	sessionManagementFailure = "SessionManagementFailure",
	logout = "Logout",
	userPolicyAccept = "UserPolicyAccept",
	userPolicyDecline = "UserPolicyDecline",
	hipaaDataAccess = "HIPAADataAccess"
}

export enum ClickEventTypeCategory {
	menuClick = "MenuClick",
	kpiClick = "KPIClick",
	hyperlinkClick = "HyperlinkClick",
	tileClick = "TileClick"
}
